// extracted by mini-css-extract-plugin
export default {"component":"DateTime_component__5oqbr"};